import gql from 'graphql-tag';

export default gql`
  fragment maintenanceFragment on Maintenance {
    id
    uuid
    maintenanceProspectPoolsTargetCount
  }
`;
